import React, { useState } from 'react';
import { Container, Icon, Item, Menu } from "semantic-ui-react";

import { connect } from 'react-redux';
import { fijarSucursal, galleryResource, isSuccess } from '../api';
import { isEmpty } from 'lodash';
import { DASHBOARD } from '../utils/Routes';
import { initialSetup } from '../actions';
import { react_app_inverted } from '../utils';
import { AppHeader } from '../components';


const Sucursales = ({ sucursales, id_sucursal, history, setup }) => {
  const [busy, setBusy] = useState(false)
  const actual = sucursales.find(v => v.id === id_sucursal)
  const data = sucursales.filter(v => v.id !== id_sucursal)

  const onClick = async (id) => {
    try {
      setBusy(true)
      const res = await fijarSucursal(id)
      if (isSuccess(res)) {
        await setup()
        history.push(DASHBOARD)
      }
    } catch (e) {
      console.log(e)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div>
      <AppHeader>
        <Menu.Item>
          <Icon name="exchange" />
          Cambiar de sucursal
        </Menu.Item>
      </AppHeader>
      <Container>
        <Item.Group divided>
          <SucursalActual { ...actual } />
          {data.map(v => <ItemSucursal key={v.id} { ...v } onClick={onClick} busy={busy} />)}
        </Item.Group>
      </Container>
    </div>
  )
}

const SucursalActual = ({ nombre }) => (
  <Item>
    <Item.Content verticalAlign="middle">
      <Item.Header>{nombre}</Item.Header>
      <Item.Extra>Estas actualmente en {nombre}</Item.Extra>
    </Item.Content>
  </Item>
)

const ItemSucursal = ({ id, nombre, active, onClick }) => {
  const onItemClick = () => onClick(id)

  return (
    <Item onClick={onClick && onItemClick} className="cs-pointer">
      <Item.Content verticalAlign="middle">
        {active && <Icon name="check"/>}
        <Item.Header as="a">{nombre}</Item.Header>
        {active && <Item.Extra>Sucursal actual</Item.Extra>}
      </Item.Content>
    </Item>
  )
}

const mapStateToProps = (state) => ({
  sucursales: state.session.sucursales.sort(sortSucursal),
  id_sucursal: state.session.sucursal
})

function sortSucursal(a, b) {
  return a.nombre < b.nombre ? -1 : 1
}

export default connect(mapStateToProps, { setup: initialSetup })(Sucursales)